module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pos-relative"
  }, [_c('Modal', {
    attrs: {
      "show": _vm.showModal,
      "show_modal_sidebar": _vm.showImportSubjects
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.create_klasses')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subject_to_the_klass')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "tabs"
  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
    staticClass: "title"
  }, [_c('h3', {
    staticClass: "flex align-center"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.schoolyear')) + "\n            "), _c('ChangeSchoolYear', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "whiteTheme": true
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.activeSchoolYears.length > 1 && _vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('a', {
    attrs: {
      "href": _vm.copySubjectsSchoolYearUrl
    }
  }, [_vm._v("\n        >> " + _vm._s(_vm.$t('vue2.year_transfer.year_transfer_link')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content pos-relative"
  }, [_c('div', {
    staticClass: "flex modal-form__titles"
  }, [_c('h3', {
    staticClass: "flex-1"
  }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.createklass.klass_name')))]) : _c('span', [_vm._v("Klasser uden fag")])]), _vm._v(" "), (_vm.showImportSubjects) ? _c('h3', {
    staticClass: "flex-2"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.klass_step')))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.klasses), function(klass, key) {
    return _c('div', {
      staticClass: "modal-form-group",
      class: [{
        'bgDelete': klass.deleteClass
      }, {
        'modal-form-group__already_created_klass': _vm.alreadyCreatedKlassesToImportSubjectTo.length > 0
      }, {
        'modal-form-group--first': key === 0
      }]
    }, [_c('div', {
      staticClass: "flex create-form"
    }, [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
      staticClass: "flex-1"
    }, [_c('input', {
      ref: klass,
      refInFor: true,
      staticClass: "namefield",
      class: [{
        'missing-input': !klass.isValid
      }, {
        'missing-input': klass.isSameName
      }],
      attrs: {
        "type": "text",
        "placeholder": "1.a"
      },
      on: {
        "input": function($event) {
          return _vm.checkAllForText(klass, key, $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "flex-1 create-form__name"
    }, [_vm._v("\n              " + _vm._s(klass.name) + "\n            ")]), _vm._v(" "), (_vm.showImportSubjects) ? _c('div', {
      staticClass: "import-klass flex-2"
    }, _vm._l((_vm.stepNumbers), function(klassStep, key) {
      return _c('div', {
        staticClass: "import-klass__step",
        class: [{
            'lastStep': key === (_vm.stepNumbers.length - 1)
          },
          {
            'firstStep': key === 0
          },
          {
            'isActive': klass.template === klassStep
          }
        ],
        on: {
          "click": function($event) {
            return _vm.setKlassImport(klass, klassStep, $event)
          },
          "mouseenter": function($event) {
            return _vm.mouseOverStep(klassStep, $event, klass)
          }
        }
      }, [_c('div', {
        staticClass: "import-klass__step__inner"
      }, [_vm._v(_vm._s(klassStep))])])
    }), 0) : _vm._e()]), _vm._v(" "), (_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
      staticClass: "delete__user",
      on: {
        "click": function($event) {
          return _vm.removeKlass(klass)
        },
        "mouseenter": function($event) {
          return _vm.addDeleteClass(klass)
        },
        "mouseleave": function($event) {
          return _vm.removeDeleteClass(klass)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.alreadyCreatedKlassesToImportSubjectTo.length < 1) ? _c('div', {
    staticClass: "add-more-button",
    on: {
      "click": _vm.pushNewKlass
    }
  }, [_c('span', {
    staticClass: "plus--icon"
  }, [_vm._v("\n            +\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "add-more-button__text"
  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.createusers.add_more')))])]) : _vm._e()])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-end pad-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.someWithSameName) ? _c('p', {
    staticClass: "error-message marg-20-right warning-text"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.warning_text')))]) : _vm._e(), _vm._v(" "), (_vm.showInactiveButton) ? _c('button', {
    staticClass: "submit-btn--disabled"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.showInactiveButton && !_vm.isAwaitingServerResponse) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submitOrSetDuration
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.showInactiveButton && _vm.isAwaitingServerResponse) ? _c('button', {
    staticClass: "submit-button submit-button--loading"
  }) : _vm._e(), _vm._v(" "), _c('StandardDurationSetting', {
    attrs: {
      "isOpenModal": _vm.isOpenDurationModal
    },
    on: {
      "close": function($event) {
        _vm.isOpenDurationModal = false
      },
      "submit": _vm.saveDuration
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "width-100",
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, [(!_vm.klassStepIsSelected) ? _c('div', {
    staticClass: "explainer-text align-center pad-20"
  }, [_c('div', {
    staticClass: "marg-10-right"
  }, [_c('span', {
    staticClass: "icon-ask icon-question3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subjects_question')))])]) : _c('div', {
    staticClass: "explainer-text align-center pad-20"
  }, [_c('div', {
    staticClass: "marg-10-right"
  }, [_c('span', {
    staticClass: "step-is-choosen icon-checkmark-circle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createklass.import_subjects_done')))])]), _vm._v(" "), _c('ShowSubjects', {
    attrs: {
      "arrowPosition": _vm.subjectsArrowPosition,
      "activeKlassStep": _vm.activeKlassStep,
      "klassStepIsSelected": _vm.klassStepIsSelected,
      "country": _vm.country
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-arrow",
    style: ({
      top: _vm.subjectsArrowPosition + 5 + 'px'
    })
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7814e750!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateKlasses/CreateKlasses.vue
// module id = 1665
// module chunks = 1